"use client";

import { ArrowRightIcon } from "lucide-react";
import Link from "next/link";
import { Button } from "../ui/button";

export function SignupCtaButton({ className }: { className?: string }) {
  return (
    <Button
      asChild
      size="lg"
      className={`text-base h-14 px-8 rounded-full font-bold group shadow-lg shadow-primary/20 hover:scale-105 active:scale-95 transition-all ${className}`}
    >
      <Link href="/cadastro">
        Começar grátis agora
        <ArrowRightIcon className="size-4 ml-2 transition-transform group-hover:translate-x-1" />
      </Link>
    </Button>
  );
}
